import { NavLink } from "react-router-dom";
import { House, UserPlus, QrCode, DoorOpen, ScanLine, Building2, BarChart3, RotateCcw, EyeOff, Eye, Store, Languages, ClipboardList, ShieldCheck } from "lucide-react";
import { useI18n, LANGS } from "@/lib/i18n/i18n";
import { toast } from "sonner";
import { useDemo } from "@/lib/demo/store";

const ITEMS = [
  { to: "/", label: "Inicio", icon: House, id: "home" },
  { to: "/registro", label: "Registro", icon: UserPlus, id: "registro" },
  { to: "/credencial", label: "Credencial", icon: QrCode, id: "credencial" },
  { to: "/acceso", label: "Accesos", icon: DoorOpen, id: "acceso" },
  { to: "/empresa/scanner", label: "Scanner", icon: ScanLine, id: "scanner" },
  { to: "/empresa/portal", label: "Portal", icon: Building2, id: "portal" },
  { to: "/dashboard", label: "Dashboard", icon: BarChart3, id: "dashboard" },
  { to: "/empresas", label: "Empresas", icon: Store, id: "empresas" },
  { to: "/empresas/inscripcion", label: "Inscripción", icon: ClipboardList, id: "inscripcion" },
  { to: "/backoffice", label: "Backoffice", icon: ShieldCheck, id: "backoffice" },
];

export const DemoNav = () => {
  const { navHidden, setNavHidden, resetDemo } = useDemo();
  const { t, lang, setLang } = useI18n();
  const nextLang = () => setLang(LANGS[(LANGS.findIndex((l) => l.id === lang) + 1) % LANGS.length].id);

  if (navHidden) {
    return (
      <button
        onClick={() => setNavHidden(false)}
        className="fixed bottom-4 left-4 z-[80] flex items-center gap-2 rounded-full bg-slate-950/80 px-3 py-2 text-[11px] font-semibold uppercase tracking-widest text-white/80 shadow-lg backdrop-blur-xl transition-colors hover:bg-slate-950"
        data-testid="demo-nav-show-button"
      >
        <Eye className="h-3.5 w-3.5" /> Demo
      </button>
    );
  }

  const reset = () => {
    resetDemo();
    toast.success(t("Demo reiniciada"), { description: t("Datos iniciales restaurados.") });
  };

  return (
    <nav
      className="fixed inset-x-0 bottom-3 z-[80] mx-auto flex w-fit max-w-[calc(100vw-16px)] items-center gap-1 rounded-full border border-white/10 bg-slate-950/90 p-1.5 text-white shadow-2xl backdrop-blur-xl"
      data-testid="demo-nav"
    >
      <span className="hidden pl-3 pr-2 text-[10px] font-bold uppercase tracking-[0.22em] text-white/40 xl:inline">Demo navigation</span>
      <div className="no-scrollbar flex items-center gap-0.5 overflow-x-auto">
        {ITEMS.map(({ to, label, icon: Icon, id }) => (
          <NavLink
            key={to}
            to={to}
            end
            data-testid={`demo-nav-${id}`}
            className={({ isActive }) =>
              `flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-2 text-xs font-semibold transition-colors ${isActive ? "bg-white text-slate-950" : "text-white/70 hover:bg-white/10 hover:text-white"}`
            }
          >
            <Icon className="h-4 w-4" />
            <span className="hidden lg:inline">{t(label)}</span>
          </NavLink>
        ))}
      </div>
      <span className="mx-1 h-6 w-px bg-white/15" />
      <button onClick={nextLang} title={t("Idioma")} className="flex shrink-0 items-center gap-1 rounded-full px-2.5 py-2 text-xs font-bold text-white/80 transition-colors hover:bg-white/10" data-testid="demo-nav-lang-button">
        <Languages className="h-4 w-4" />{lang.toUpperCase()}
      </button>
      <button onClick={reset} title={t("Reiniciar demo")} className="flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-2 text-xs font-semibold text-white/70 transition-colors hover:bg-upv hover:text-white" data-testid="demo-nav-reset-button">
        <RotateCcw className="h-4 w-4" /><span className="hidden xl:inline">{t("Reiniciar demo")}</span>
      </button>
      <button onClick={() => setNavHidden(true)} title={t("Ocultar")} className="flex shrink-0 items-center rounded-full px-2.5 py-2 text-white/60 transition-colors hover:bg-white/10 hover:text-white" data-testid="demo-nav-hide-button">
        <EyeOff className="h-4 w-4" />
      </button>
    </nav>
  );
};
